module.exports = __webpack_public_path__ + "static/reigas_imgs_ferrre-c87886c69aa3382774bde5b1f5cc18aa.png";